import React from "react";

const AboutHeatSection = ({ ceremony }) => (
  <div className="space-y-3">
    <div className="rounded-2xl p-4 text-sm text-left space-y-2 bg-violet-300/[0.12] border border-violet-300 text-gray-500">
      <p>
        📅 <strong className="text-brand-dark">Ceremonia:</strong>{" "}
        {ceremony.date}
      </p>
      <p>
        📍 <strong className="text-brand-dark">{ceremony.location}</strong>
      </p>
    </div>

    <div className="rounded-2xl p-4 text-sm text-center font-semibold bg-pink-300/[0.12] border border-pink-300 text-brand-primary">
      🎤 {ceremony.note}
    </div>
  </div>
);

export default AboutHeatSection;
